import {
  SET_LIST,
  SET_TOTAL,
  SET_OFFSET,
  SET_MAX
} from './mutation-types';

export default {
  [SET_LIST] (state,
    items
  ) {
    state['subCategories'] = [
      ...items
    ];
  },
  [SET_TOTAL] (state,
    total
  ) {
    state['total'] = total;
  },
  [SET_OFFSET] (state,
    offset
  ) {
    state['offset'] = offset;
  },
  [SET_MAX] (state,
    max
  ) {
    state['max'] = max;
  },

};
